import React from 'react';

import useAuth from '@hooks/useAuth';
import { hasAllPermissions } from '@utils/permission';

// Port từ license-cms/source/src/compoments/common/elements/ElementWithPermission.js.
// Nguồn đọc userData từ sessionStorage; ở đây lấy `permissionCodes` từ useAuth (redux) — cùng dữ liệu.
//
// Quy tắc giữ NGUYÊN: mảng quyền RỖNG ⇒ HIỆN; có phần tử `undefined` ⇒ ẨN.
const ElementWithPermission = ({ children, permissions = [] }) => {
    const { permissionCodes } = useAuth();
    return <>{hasAllPermissions(permissions, permissionCodes || []) ? children : null}</>;
};

export default ElementWithPermission;
